import { withStyles } from '@material-ui/core/styles';
import { Slider } from '@material-ui/core';

export const RateSlider = withStyles({
  mark: {
    height: 0
  },
  markLabel: {
    height: 15,
    zIndex: 999,
    top: 17,
    fontSize: '20px'
  },

  thumb: {
    top: 15,
    height: 40,
    width: 40,
    fontSize: 20,
    alignContent: 'center',
    justifyContent: 'center',
    color: '#000',
    backgroundColor: '#fff',
    border: '1px solid #efefef',
    marginTop: -5,
    marginLeft: -20,
    boxShadow: '1px 2px 3px 0px rgb(144 144 144 / 30%);',
    '&:focus, &:hover, &$active': {
      boxShadow: '#ccc 0 2px 3px 1px'
    },
    '& .bar': {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: '#A0A0A0',
      marginLeft: 10,
      marginRight: 1
    }
  },
  active: {},
  valueLabel: {
    color: 'transparent'
  },
  track: {
    background: 'transparent',
    height: 31,
    borderRadius: 15
  },
  root: {
    height: 30,
    width: '80%',
    alignContent: 'center',
    justifyContent: 'center'
  },
  rail: {
    top: 15,
    width: '114%',
    left: '-7%',
    alignSelf: 'center',

    opacity: 0.8,
    background: 'linear-gradient(to right,red,yellow,lime)',
    height: 31,
    borderRadius: 20
  }
})(Slider);
